import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import './style.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { storeInit } from 'reduxModules/storeConfig';
import { CookiesProvider } from 'react-cookie';
import { ThemeProvider } from './theme/ThemeContext';
import App from './App';
import { Main } from 'components/templates';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from 'components/services/ProtectedRoute';


const store = storeInit(); // Adding a preloaded state, replaces the initial state 

interface ProtectedMainProps {
  tool: any;  // Consider creating a proper type for tool
}

// Define a component that wraps Main with ProtectedRoute
const ProtectedMain: React.FC<ProtectedMainProps> = ({ tool }) => (
  <ProtectedRoute>
    <Main tool={tool} />
  </ProtectedRoute>
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <CssBaseline /> {/* Provides consistent baseline styles */}
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <AuthProvider>
            <ToastProvider>
              <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Routes>
                <Route path='/*' element={<App />} >
                  {/* Public home route */}
                  <Route index element={<div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                  </div>} />
                  
                  <Route path="*" element={<h1 className="text-center mt-5">The Design Tool you're requesting does not exist!</h1>} />
                </Route>
              </Routes>
              </BrowserRouter>
            </ToastProvider>
          </AuthProvider>
        </CookiesProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
